import React, { Component, useEffect, useState } from 'react';
import InvoicesTable from './InvoicesTable';
import InvoiceService from '../../services/WebInvoiceService'
import { InvoiceType } from 'common/constants'
import SearchByDates from './invoices-search/SearchByDates';
import CurrencyFormatter from 'common/currencyFormatter';
import ThemedTableRow from '../shared/ThemedTableRow';
import Checkbox from '@material-ui/core/Checkbox';
import profileService from '../../services/WebProfileService';
import DeleteInvoiceDialog from './DeleteInvoiceDialog';
import DateUtility from 'common/DateUtility';

import {
  TableHead,
  TableCell,
  TableRow,
  Button
} from '@material-ui/core';

const ENTER_KEY = 13;

const styles = {
  searchAndDeleteContainer: {
      display: 'flex',
      flexWrap: 'wrap',
  },
  btn: {
    alignSelf:"center",
  }
}


export default function InvoicesForCustomer(props) {

  const { customerId } = props.match.params;
  const { invoiceType } = props;
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [invoices, setInvoices] = useState('')
  const [unpaidOnly, setUnpaidOnly] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isDeleteButtonEnabled, setIsDeleteButtonEnabled ] = useState(false);
  const [isDeleteInvoiceDialogOpen, setIsDeleteInvoiceDialogOpen] = useState(false);

  useEffect(() => {    
    profileService.getProfile( (results) => {
      setIsAdmin(results.admin);
    });
  });

  useEffect(() => {
    InvoiceService.searchInvoicesByDate(fromDate, toDate, customerId, invoiceType, null, null, (invoices) => {
      setInvoices(invoices);
    });
  }, [fromDate,toDate, customerId, invoiceType]);

  function checkedInvoices() {
    return invoices ? invoices.filter( (invoice) => { return invoice.checked }) : [];
  }

  function genTableHeader() {
    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox"/>
          <TableCell>Invoice</TableCell>
          <TableCell>Location</TableCell>
          <TableCell id="date-table-cell">Date</TableCell>
          <TableCell>Invoice Total</TableCell>
          <TableCell>Unit</TableCell>
          <TableCell>Status</TableCell>
        </TableRow>
      </TableHead>
    )
  }

  function isPaid(invoice) {
    return ((invoice.postedToReceivables - invoice.invoiceTotal) >= 0) ? "Paid " : "";
  }

  function rowSelected(invoice, which, rowClicked) {
    if (which === ENTER_KEY) {
      rowClicked(invoice);
    }
  }

  function invoiceSelector(invoice) {
    return (
      <TableCell padding="none">
        <Checkbox
          id='select'
          indeterminate={false}
          checked={invoice.checked}
          onClick={() => {
            invoice.checked = !invoice.checked;
            setIsDeleteButtonEnabled(checkedInvoices().length > 0);
          }} />
      </TableCell>
    )
  }


  function genTableRows(invoices, rowClicked) {
    let invoicePrefix = InvoiceType.getInvoicePrefix(invoiceType);
    let typeOfDate = InvoiceType.actionKey(invoiceType);
    const { dateToString } = DateUtility;

    if (!invoices) {
      return null;
    }

    return invoices.map((invoice) => {
      if (unpaidOnly && isPaid(invoice)) {
        return null;
      }
      let invoiceId = InvoiceType.getNumberForInvoice(invoiceType, invoice);
      return (
        <ThemedTableRow
          onClick={ (event) => { 
            if(event.target.id !== 'select') { rowClicked(invoice) } 
          } }
          className='invoice-row'
          tabIndex={0}
          onKeyDown={e => rowSelected(invoice, e.which, rowClicked)}
          key={`invoice-${invoice.id}`}>
          {isAdmin ? invoiceSelector(invoice) : <TableCell padding="checkbox"/>}
          <TableCell id="invoice">{invoicePrefix}{invoiceId}</TableCell>
          <TableCell id="location" >{invoice.location}</TableCell>
          <TableCell id={typeOfDate}>{dateToString(invoice[typeOfDate])}</TableCell>
          <TableCell id="invoiceTotal">{CurrencyFormatter.formatUSD(invoice.invoiceTotal)}</TableCell>
          <TableCell id="unit">{invoice.unit}</TableCell>
          <TableCell id="paid">{isPaid(invoice)}</TableCell>
        </ThemedTableRow>
      )
    });
  }

  function deleteInvoices(invoiceType) {
    const invoiceNumbers = checkedInvoices().map( (invoice) => InvoiceType.getNumberForInvoice(invoiceType,invoice));

    InvoiceService.deleteInvoices(invoiceNumbers, invoiceType, (results) => {  
        InvoiceService.searchInvoicesByDate(fromDate, toDate, customerId, invoiceType, null, null, (invoices) => {
          setInvoices(invoices);
          setIsDeleteInvoiceDialogOpen(false);  
          setIsDeleteButtonEnabled(false);  
        });        
    });
  }

  return (<div>
    <div style={styles.searchAndDeleteContainer}>
      <SearchByDates
        customerId={customerId}
        setFromDate={setFromDate}
        setToDate={setToDate}
        onFilterChanged={checked => setUnpaidOnly(checked)}
      />
      {isAdmin ? <Button
        style={styles.btn}
        disabled={!isDeleteButtonEnabled}
        id='delete-invoice-button'
        variant='contained'
        onClick={() => setIsDeleteInvoiceDialogOpen(true) }
        color="primary">Delete</Button> : null}
    </div>
    <InvoicesTable
      generateTableHeader={genTableHeader}
      generateTableRows={(rowClicked) => genTableRows(invoices, rowClicked)}
      invoices={invoices}
      invoiceType={props.invoiceType} />
    <DeleteInvoiceDialog 
      invoicesToDelete={checkedInvoices()}
      open={isDeleteInvoiceDialogOpen}
      onDeleteInvoices={ () => {
        deleteInvoices(props.invoiceType)
      }}
      onClose={() => {
        setIsDeleteInvoiceDialogOpen(false);
      }}/>
  </div>);
}


export class ShopInvoicesForCustomer extends Component{
  render() {
    return <InvoicesForCustomer {...this.props} invoiceType={InvoiceType.SHOP}/>
  }
}

export class TowInvoicesForCustomer extends Component{
  render() {
    return <InvoicesForCustomer {...this.props} invoiceType={InvoiceType.TOW}/>
  }
}

export class LoadInvoicesForCustomer extends Component{
  render() {
    return <InvoicesForCustomer {...this.props} invoiceType={InvoiceType.LOAD}/>
  }
}
